export const CONTEXT = '[Image Upload]';

export class GeneratePresignedUrl {
  static readonly type = `${CONTEXT} Generate Presigned URL`;
  constructor(
    public file: File,
    public fileType: string,
    public uploadType?: string
  ) {}
}

export class UploadImageToS3 {
  static readonly type = `${CONTEXT} Upload Image to S3`;
  constructor(
    public file: File,
    public presignedUrl: string
  ) {}
}

export class UploadImageAndScan {
  static readonly type = `${CONTEXT} Upload Image and Scan`;
  constructor(
    public file: File,
    public location?: { latitude: number; longitude: number; accuracy: number }
  ) {}
}

export class AddUploadedImage {
  static readonly type = `${CONTEXT} Add Uploaded Image`;
  constructor(
    public image: any,
    public fileType: string
  ) {}
}

export class RemoveUploadedImage {
  static readonly type = `${CONTEXT} Remove Uploaded Image`;
  constructor(public image: any) {}
}

export class ClearUploadedImages {
  static readonly type = `${CONTEXT} Clear Uploaded Images`;
}

export class SetUploadProgress {
  static readonly type = `${CONTEXT} Set Upload Progress`;
  constructor(
    public imageKey: string,
    public progress: number
  ) {}
}

export class SetUploadStatus {
  static readonly type = `${CONTEXT} Set Upload Status`;
  constructor(
    public imageKey: string,
    public status: 'uploading' | 'uploaded' | 'failed' | 'scanning' | 'completed'
  ) {}
}

export class SetScanResult {
  static readonly type = `${CONTEXT} Set Scan Result`;
  constructor(
    public imageKey: string,
    public result: any
  ) {}
}

export class ResetUploadState {
  static readonly type = `${CONTEXT} Reset Upload State`;
} 